import { useGetUkCustomsFiles } from '@dhl/mdp-api'
import type { CustomsFile } from '~/modules/ppp/submodules/customs/model'
import { convertToCustomsFile } from '~/modules/ppp/submodules/customs/model/conversions/convertToCustomsFile'

/**
 * Fetches the customs files for the given dates.
 * @param from - The start date for fetching customs files. This should be a Unix timestamp in milliseconds.
 * @param to - The end date for fetching customs files. This should be a Unix timestamp in milliseconds.
 * @returns An array of customs files for the given dates.
 */
export const useCustomsFiles = (from: number, to: number): { data: CustomsFile[]; isLoading: boolean } => {
  const { data, isLoading } = useGetUkCustomsFiles({ from, to })

  const files = data?.map(convertToCustomsFile)

  return {
    data: files ?? [],
    isLoading,
  }
}
